export default "__VITE_ASSET__Bz5CT4zE__"